import { cva } from 'class-variance-authority'
import { Slot } from 'radix-ui'
import * as React from 'react'
import { cn } from '../../lib/cn'
import type { TextProps, TextVariant } from './text.types'

export const textVariants = cva('', {
  variants: {
    variant: {
      h1: 'cs-type-h1',
      h2: 'cs-type-h2',
      h3: 'cs-type-h3',
      h4: 'cs-type-h4',
      body: 'cs-type-body',
      label: 'cs-type-label',
    },
  },
  defaultVariants: { variant: 'body' },
})

const variantToElement: Record<TextVariant, React.ElementType> = {
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  body: 'p',
  label: 'span',
}

const Text = React.forwardRef<HTMLElement, TextProps>(
  ({ className, variant, asChild = false, ...props }, ref) => {
    const Comp: React.ElementType = asChild
      ? Slot.Slot
      : variantToElement[variant ?? 'body']
    return (
      <Comp
        ref={ref}
        className={cn(textVariants({ variant }), className)}
        {...props}
      />
    )
  },
)
Text.displayName = 'Text'

export { Text }
